import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Filter, Pagination, RestService, Sort} from '../../../lib/yii2-rest/rest.service';
import {map} from 'rxjs/operators';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-user-selection',
  templateUrl: './user-selection.component.html',
  styleUrls: ['./user-selection.component.scss'],
  providers: [
    {
      provide: RestService,
      useClass: RestService
    }
  ]
})
export class UserSelectionComponent implements OnInit {
  @Input() addAllUsersOptions = false;
  @Input() roleFilter = null;
  @Input() selectedUserId: BehaviorSubject<number | 'all'>;
  formGroup: FormGroup;
  items: Observable<any> = new Observable<any>();
  constructor(
    protected restService: RestService,
    protected formBuilder: FormBuilder,
    protected translateService: TranslateService,
  ) { }
  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      userId: this.formBuilder.control(this.selectedUserId.getValue(), [Validators.required])
    });
    this.formGroup.controls.userId.valueChanges.subscribe(
      oldValue => this.selectedUserId.next(this.formGroup.controls.userId.value)
    );
    const filter = this.roleFilter ? new Filter('UserSearch', {role: this.roleFilter}) : null;
    this.items = this.restService.list(
      'user',
      new Pagination(1, 500),
      filter,
      new Sort('login'),
      'id,login',
      ''
    ).pipe(
      map(
        response => this.addAllUsersOptions ?
          [{id: 'all', login: this.translateService.instant('<all users>')}, ...response.items]
          : response.items
      )
    );
  }

}
